import axios from 'axios'
import { isVideo } from 'shared'

const { REACT_APP_CREATORS_API_URL } = process.env

export interface ResponseList<D> {
  data: D
  count: number
  pages: number
  page: number
  totalCount: number
}

export const API = axios.create({
  baseURL: REACT_APP_CREATORS_API_URL,
  withCredentials: true,
})

export const uploadMedia = (file: File & { path?: string }) => {
  const form = new FormData()
  form.append('file', file)
  return API.post(
    `/upload/${isVideo(file?.path || '') ? 'video' : 'image'}`,
    form,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  ).then((res) => res.data)
}
